export const FEATURE_FLAGS = {
  MESSAGE_CENTER: "AskAMI.MessageCenter",
} as const;
